import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import config from '../../config';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem(config.athleteLogged) ? (
        <Component {...props} />
      ) : (
        <Redirect from='*' to='/login' />
      )
    }
  />
);

export default PrivateRoute;
